import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import FontAwesome from 'react-fontawesome'

const StyledSocialLinks = styled.div`
	display: flex;

	.fa {
		color: ${props => props.color || '#FFF'};
		transition: color 0.5s;

		&:hover {
			color: ${props => props.hover};
		}
	}

	a:not(:last-child) {
		margin-right: 4rem;
	}
`

/**
 *
 * @param {string} props.color
 * Controls the color of the link
 *
 * @param {string} props.hover
 * Controls the color of the link in hover state
 */

const SocialLinks = props => (
	<StyledSocialLinks
		color={props.color}
		hover={props.hover}
		className="social-links">
		<a
			href="https://www.facebook.com/muviflex"
			target="_blank"
			rel="noopener noreferrer">
			<FontAwesome className="icon" name="facebook" size="3x" />
		</a>
		<a
			href="https://www.instagram.com/muviflex/"
			target="_blank"
			rel="noopener noreferrer">
			<FontAwesome className="icon" name="instagram" size="3x" />
		</a>
	</StyledSocialLinks>
)

export default SocialLinks
